'use client';

import { createContext } from 'react';

export interface ProductCompareItem {
   id: string;
   name: string;
}

export interface ProductCompareContextValue {
   productItems: ProductCompareItem[];
   isInitialized: boolean;
   addProduct: (productId: string, productName: string) => void;
   removeProduct: (productId: string) => void;
   removeAllProducts: () => void;
}

const defaultProductCompareContext: ProductCompareContextValue = {
   productItems: [],
   isInitialized: false,
   addProduct: () => {},
   removeProduct: () => {},
   removeAllProducts: () => {}
};

export const ProductCompareContext = createContext<ProductCompareContextValue>(defaultProductCompareContext);
